export default class ClubDogMemberConfiguration {
    static fromData(data) {
        if (!data) {
            return;
        }

        let clubDogMemberConfiguration = new ClubDogMemberConfiguration();

        clubDogMemberConfiguration.id = data.id || null;
        clubDogMemberConfiguration.fileUploadIntro = data.fileUploadIntro;
        clubDogMemberConfiguration.dogsIntro = data.dogsIntro;
        clubDogMemberConfiguration.askDogs = data.askDogs;
        clubDogMemberConfiguration.dogChipNumberMandatory = data.dogChipNumberMandatory;
        clubDogMemberConfiguration.dogBreedingBookNumberMandatory = data.dogBreedingBookNumberMandatory;

        return clubDogMemberConfiguration;
    }

    serialize() {
        return Object.assign({}, this);
    }
}
